/*!
 * Habtium: the Habbo universe on your hand.
 * 
 * @link https://habtium.es/about
 * @copyright 2006 - 2016 Habtium
 */

/*!
 * Forum script.
 *
 * @author Fran Torregrosa <fran@axiomer.com>
 */
var Forum = {
	topic: App.get(3),
	
	init : function() {
		
		/* Replies */
		Forum.replies.init();
		
		/* Likes */
		Forum.likes.init();
		
		// In edit
		if(App.get(2)=='edit')
			$(document).scrollTop($('main').offset().top-$('#menu').height()-10);
		
		// In reply
		if(App.get(2)=='reply') {
			Forum.replyListener();
			Forum.spoilerListener();
		}
		
		// In topic
		if(App.get(2)=='topic') {
		
			/* Follow */
			$('.btn-follow').click(function(e) {
				e.preventDefault();
				var btn = $(this);
				Api.post('/forum/' + Forum.topic, {follow: !btn.hasClass('active')}, function(data) {
					
					if(data.status=='success') {
						if(!btn.hasClass('active')) {
							Language.get('main.item_following').then(function (strings) {
								$('.btn-follow').addClass('active animated zoomIn noClick').children('.text').text(strings[0]);
							});
							
							
							setTimeout(function() {
								$('.btn-follow').removeClass('noClick animated zoomIn');
							}, 1000);
						} else {
							Language.get('main.item_follow').then(function (strings) {
								$('.btn-follow').removeClass('active').children('.text').text(strings[0]);
							});
						}
					}
					
				});
			}).hover(function() {
				if($(this).hasClass('active'))
					Language.get('main.item_stop_follow').then(function (strings) {
						$(this).children('.text').text(strings[0]);
					});
			}, function() {
				if($(this).hasClass('active'))
					Language.get('main.item_following').then(function (strings) {
						$(this).children('.text').text(strings[0]);
					});
			});
			
			/* Spoiler */
			Forum.spoilerListener();
			
			/* Reply-all */
			$('.btn-reply-all').click(function(e) {
				e.preventDefault();
				
				var replies = Lockr.get('replies');
				if(replies) {
					replies = '/' + replies.toString();
					window.location.href = $(this).attr('href') + replies;
					Forum.replies.remove();
				} else {
					$.get('/templates/forum.reply.html', function(data) {
						history.pushState({action: 'reply-all'}, History.title, '/forum/reply/' + App.get(3));
						Visor.open({body: data, width: 940, title: 'Respondiendo al tema'});
						Visor.onClose = function() {
							history.pushState({action: 'topic'}, History.title, '/forum/topic/' + App.get(3));
							//window.history.go(-1);
							Visor.onClose = null;
						};
						Forum.replyListener();
					});
				}
				
			});
			history.replaceState({action: 'topic'}, History.title, null);
			window.addEventListener('popstate', function(e) {
				
				if(e.state) {
					if(e.state.action=='reply-all') {
						$('.btn-reply-all').first().click();
					} else if(e.state.action=='topic') {
						Visor.close();
					}
				}
			});
			
		}
		
	},
	
	replyListener: function() {
		if(!App.get(4)) {
			var query = 'forum-reply-' + Forum.topic;
			var saved = Lockr.get(query);
			var save = function() {
				$('#reply_body').val() ? Lockr.set(query, $('#reply_body').val(), 5) : Lockr.rm(query);
			};
			
			if(saved)
				$('#reply_body').val(saved);
			
			var locked = false;
			$('#reply_body').keypress(function(e) {
				if(!locked) {
					locked = true;
					setTimeout(function() {
						save();
						locked = false;
					}, 3000);
				}
			}).on('change', save);
			
			setTimeout(function() {
				setCaretPosition($('#reply_body'), 0);
				$('form .button[name=reply], form > a.btn-cancel').click(function() {
					Lockr.rm(query);
				});
			}, 1000);
		}
	},
	
	spoilerListener: function() {
		$('.btn-spoiler').click(function() {
			var btn = $(this);
			var isOpened = btn.hasClass('active');
			
			btn.next()[isOpened ? 'slideUp' : 'slideDown']('fast', function() {
				Language.get((isOpened ? 'show' : 'hide')+'_content').then(function (strings) {
					btn.toggleClass('active', !isOpened).html(strings[0]);
				});
			});
		});
		
		$('.btn-spoiler-all').click(function(e) {
			e.preventDefault();
			
			var btn = $(this);
			var spoilers = btn.parent().parent().children('.text').find('.decoda-spoiler-button');
			
			if(btn.hasClass('active')) {
				btn.removeClass('active').children('span').removeClass('halflings-resize-small');
				spoilers.removeClass('spoiler-open').click();
			} else {
				btn.addClass('active').children('span').addClass('halflings-resize-small');
				spoilers.addClass('spoiler-open').click();
			}
		});
	},
	
	likes : {
		init : function() {
			var btns = $('.btn-like');
			
			(function putLikes() {
				if(btns[0])
					Api.get('/likes/status/message/' + $(btns[0]).data('id'), {}, function(data) {
						//$(btns[0]).append(' <span class="count'+ (data.liked ? 'liked' : '') +'">'+ (data.amount==0 ? '' : data.amount) +'</span>');
						Forum.likes.status($(btns[0]));
						btns.splice(0, 1);
						putLikes();
					});
			})();
			
			btns.mouseenter(function() {
				var btn = $(this);
				var container = btn.parent();
				timeout = setTimeout(function() {
					
					Language.get('main.item_liked').then(function (strings) {
						btn.popover({title: strings[0], container: container, html: true, placement: 'bottom', content: '<center><img src="//cdn.habtium.com/management/ajax-loader.gif"></center>', trigger: 'manual'});
						btn.popover('show');
					});
					
					Api.get('/likes/message/' + btn.data('id'), {}, function(data) {
						if(data.error) {
							if(data.error.identifier == 'empty_set')
								Language.get('main.item_liked_nobody').then(function (strings) {
									btn.data("bs.popover").options.content = strings[0];
									btn.popover('show');
								});
						} else {
						
							Accounts.getIfNot(data, function() {
								var list = '';
								for(var i in data) {
									var account = accounts[data[i]];
									list += '<div style="display: table;"><a title="'+account.username+'" href="/'+ account.username +'"><img style="display: table-cell;width: 25px;height: 25px;border-radius: 100%;background-size: cover;background-repeat: no-repeat;background-position: center center!important;" width="25" src="'+ account.avatar +'" /></a><a style="display:table-cell;" href="/'+ account.username +'">'+ account.username +'</a></div>';
								}
								btn.data("bs.popover").options.content = list;
								btn.popover('show');
							});
							
						}
						container.mouseleave(function() {
							btn.popover('hide');
						});
					});
					
				}, 1000);
				
				container.mouseleave(function() {
					clearTimeout(timeout);
				});
				
				
			}).click(function(e) {
				e.preventDefault();
				clearTimeout(timeout);
				var btn = $(this);
				
				if(!btn.hasClass('active')) {
					// Like
					Api.post('/likes/message/' + btn.data('id'), {}, function(data) {
						if(data.success) {
							btn.addClass('active animated zoomIn');
							setTimeout(function() {
								btn.removeClass('animated zoomIn');
							}, 1000);
							Forum.likes.status(btn);
						}
					});
					
				} else {
					// Unlike
					Api.delete('/likes/message/' + btn.data('id'), {}, function(data) {
						if(data.success) {
							btn.removeClass('active');
							Forum.likes.status(btn);
						}
					});
				}
				
				
			});
		},
		status: function(btn) {
			Api.get('/likes/status/message/' + btn.data('id'), {}, function(data) {
				btn.children('.count').html(data.amount==0 ? '' : data.amount);
				if(data.liked)
					btn.addClass('active');
			});
		}
	},
	replies : {
		init : function() {
			var timeout;
			var savedTopicId = false;
			
			// Check
			if(Lockr.get('replies-topic') != Forum.topic)
				Forum.replies.remove();
			
			// Reply button
			$('.btn-reply').mousedown(function() {
				if(!$(this).hasClass('active')) {
					var btn = $(this);
					timeout = setTimeout(function() {
						// Add element
						var replies = Forum.replies.get();
						replies.push(btn.data('id'));
						Lockr.set('replies', replies);
						if(!savedTopicId) {
							Lockr.set('replies-topic', Forum.topic);
							savedTopicId = true;
						}
						btn.addClass('active animated zoomIn noClick');
						setTimeout(function() {
							btn.removeClass('noClick animated zoomIn');
						}, 1000);
					}, 500);
					btn.mouseleave(function() {	clearTimeout(timeout)	}).mouseup(function() {	clearTimeout(timeout)	});
				}
			}).click(function(e) {
				e.preventDefault();
				if(!$(this).hasClass('noClick'))
					if(!$(this).hasClass('active'))
						window.location.href = $(this).attr('href');
					else {
						// Remove element
						$(this).removeClass('active');
						var replies = Forum.replies.get();
						var index = replies.indexOf($(this).data('id'));
						if (index > -1)	replies.splice(index, 1);
						Lockr.set('replies', replies);
					}
				timeout = null;
			});
			
		},
		get : function() {
			var replies = Lockr.get('replies');
			if(!replies)	replies = [];
			return replies;
		},
		remove : function() {
			Lockr.rm('replies');
			Lockr.rm('replies-topic');
		}
		
	}
	
};

/*!
 * Bootstrap v3.3.7 (http://getbootstrap.com)
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 */

/*!
 * Generated using the Bootstrap Customizer (http://getbootstrap.com/customize/?id=8103e72e9bb0ea6ba9f4a10f0c8a8cc8)
 * Config saved to config.json and https://gist.github.com/8103e72e9bb0ea6ba9f4a10f0c8a8cc8
 */
if (typeof jQuery === 'undefined') {
  throw new Error('Bootstrap\'s JavaScript requires jQuery')
}
+function ($) {
  'use strict';
  var version = $.fn.jquery.split(' ')[0].split('.')
  if ((version[0] < 2 && version[1] < 9) || (version[0] == 1 && version[1] == 9 && version[2] < 1) || (version[0] > 3)) {
    throw new Error('Bootstrap\'s JavaScript requires jQuery version 1.9.1 or higher, but lower than version 4')
  }
}(jQuery);

/* ========================================================================
 * Bootstrap: tooltip.js v3.3.7
 * http://getbootstrap.com/javascript/#tooltip
 * Inspired by the original jQuery.tipsy by Jason Frame
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // TOOLTIP PUBLIC CLASS DEFINITION
  // ===============================

  var Tooltip = function (element, options) {
    this.type       = null
    this.options    = null
    this.enabled    = null
    this.timeout    = null
    this.hoverState = null
    this.$element   = null
    this.inState    = null

    this.init('tooltip', element, options)
  }

  Tooltip.VERSION  = '3.3.7'

  Tooltip.TRANSITION_DURATION = 150

  Tooltip.DEFAULTS = {
    animation: true,
    placement: 'top',
    selector: false,
    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
    trigger: 'hover focus',
    title: '',
    delay: 0,
    html: false,
    container: false,
    viewport: {
      selector: 'body',
      padding: 0
    }
  }

  Tooltip.prototype.init = function (type, element, options) {
    this.enabled   = true
    this.type      = type
    this.$element  = $(element)
    this.options   = this.getOptions(options)
    this.$viewport = this.options.viewport && $($.isFunction(this.options.viewport) ? this.options.viewport.call(this, this.$element) : (this.options.viewport.selector || this.options.viewport))
    this.inState   = { click: false, hover: false, focus: false }

    if (this.$element[0] instanceof document.constructor && !this.options.selector) {
      throw new Error('`selector` option must be specified when initializing ' + this.type + ' on the window.document object!')
    }

    var triggers = this.options.trigger.split(' ')

    for (var i = triggers.length; i--;) {
      var trigger = triggers[i]

      if (trigger == 'click') {
        this.$element.on('click.' + this.type, this.options.selector, $.proxy(this.toggle, this))
      } else if (trigger != 'manual') {
        var eventIn  = trigger == 'hover' ? 'mouseenter' : 'focusin'
        var eventOut = trigger == 'hover' ? 'mouseleave' : 'focusout'

        this.$element.on(eventIn  + '.' + this.type, this.options.selector, $.proxy(this.enter, this))
        this.$element.on(eventOut + '.' + this.type, this.options.selector, $.proxy(this.leave, this))
      }
    }

    this.options.selector ?
      (this._options = $.extend({}, this.options, { trigger: 'manual', selector: '' })) :
      this.fixTitle()
  }

  Tooltip.prototype.getDefaults = function () {
    return Tooltip.DEFAULTS
  }

  Tooltip.prototype.getOptions = function (options) {
    options = $.extend({}, this.getDefaults(), this.$element.data(), options)

    if (options.delay && typeof options.delay == 'number') {
      options.delay = {
        show: options.delay,
        hide: options.delay
      }
    }

    return options
  }

  Tooltip.prototype.getDelegateOptions = function () {
    var options  = {}
    var defaults = this.getDefaults()

    this._options && $.each(this._options, function (key, value) {
      if (defaults[key] != value) options[key] = value
    })

    return options
  }

  Tooltip.prototype.enter = function (obj) {
    var self = obj instanceof this.constructor ?
      obj : $(obj.currentTarget).data('bs.' + this.type)

    if (!self) {
      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
      $(obj.currentTarget).data('bs.' + this.type, self)
    }

    if (obj instanceof $.Event) {
      self.inState[obj.type == 'focusin' ? 'focus' : 'hover'] = true
    }

    if (self.tip().hasClass('in') || self.hoverState == 'in') {
      self.hoverState = 'in'
      return
    }

    clearTimeout(self.timeout)

    self.hoverState = 'in'

    if (!self.options.delay || !self.options.delay.show) return self.show()

    self.timeout = setTimeout(function () {
      if (self.hoverState == 'in') self.show()
    }, self.options.delay.show)
  }

  Tooltip.prototype.isInStateTrue = function () {
    for (var key in this.inState) {
      if (this.inState[key]) return true
    }

    return false
  }

  Tooltip.prototype.leave = function (obj) {
    var self = obj instanceof this.constructor ?
      obj : $(obj.currentTarget).data('bs.' + this.type)

    if (!self) {
      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
      $(obj.currentTarget).data('bs.' + this.type, self)
    }

    if (obj instanceof $.Event) {
      self.inState[obj.type == 'focusout' ? 'focus' : 'hover'] = false
    }

    if (self.isInStateTrue()) return

    clearTimeout(self.timeout)

    self.hoverState = 'out'

    if (!self.options.delay || !self.options.delay.hide) return self.hide()

    self.timeout = setTimeout(function () {
      if (self.hoverState == 'out') self.hide()
    }, self.options.delay.hide)
  }

  Tooltip.prototype.show = function () {
    var e = $.Event('show.bs.' + this.type)

    if (this.hasContent() && this.enabled) {
      this.$element.trigger(e)

      var inDom = $.contains(this.$element[0].ownerDocument.documentElement, this.$element[0])
      if (e.isDefaultPrevented() || !inDom) return
      var that = this

      var $tip = this.tip()

      var tipId = this.getUID(this.type)

      this.setContent()
      $tip.attr('id', tipId)
      this.$element.attr('aria-describedby', tipId)

      if (this.options.animation) $tip.addClass('fade')

      var placement = typeof this.options.placement == 'function' ?
        this.options.placement.call(this, $tip[0], this.$element[0]) :
        this.options.placement

      var autoToken = /\s?auto?\s?/i
      var autoPlace = autoToken.test(placement)
      if (autoPlace) placement = placement.replace(autoToken, '') || 'top'

      $tip
        .detach()
        .css({ top: 0, left: 0, display: 'block' })
        .addClass(placement)
        .data('bs.' + this.type, this)

      this.options.container ? $tip.appendTo(this.options.container) : $tip.insertAfter(this.$element)
      this.$element.trigger('inserted.bs.' + this.type)

      var pos          = this.getPosition()
      var actualWidth  = $tip[0].offsetWidth
      var actualHeight = $tip[0].offsetHeight

      if (autoPlace) {
        var orgPlacement = placement
        var viewportDim = this.getPosition(this.$viewport)

        placement = placement == 'bottom' && pos.bottom + actualHeight > viewportDim.bottom ? 'top'    :
                    placement == 'top'    && pos.top    - actualHeight < viewportDim.top    ? 'bottom' :
                    placement == 'right'  && pos.right  + actualWidth  > viewportDim.width  ? 'left'   :
                    placement == 'left'   && pos.left   - actualWidth  < viewportDim.left   ? 'right'  :
                    placement

        $tip
          .removeClass(orgPlacement)
          .addClass(placement)
      }

      var calculatedOffset = this.getCalculatedOffset(placement, pos, actualWidth, actualHeight)

      this.applyPlacement(calculatedOffset, placement)

      var complete = function () {
        var prevHoverState = that.hoverState
        that.$element.trigger('shown.bs.' + that.type)
        that.hoverState = null

        if (prevHoverState == 'out') that.leave(that)
      }

      $.support.transition && this.$tip.hasClass('fade') ?
        $tip
          .one('bsTransitionEnd', complete)
          .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
        complete()
    }
  }

  Tooltip.prototype.applyPlacement = function (offset, placement) {
    var $tip   = this.tip()
    var width  = $tip[0].offsetWidth
    var height = $tip[0].offsetHeight

    // manually read margins because getBoundingClientRect includes difference
    var marginTop = parseInt($tip.css('margin-top'), 10)
    var marginLeft = parseInt($tip.css('margin-left'), 10)

    // we must check for NaN for ie 8/9
    if (isNaN(marginTop))  marginTop  = 0
    if (isNaN(marginLeft)) marginLeft = 0

    offset.top  += marginTop
    offset.left += marginLeft

    // $.fn.offset doesn't round pixel values
    // so we use setOffset directly with our own function B-0
    $.offset.setOffset($tip[0], $.extend({
      using: function (props) {
        $tip.css({
          top: Math.round(props.top),
          left: Math.round(props.left)
        })
      }
    }, offset), 0)

    $tip.addClass('in')

    // check to see if placing tip in new offset caused the tip to resize itself
    var actualWidth  = $tip[0].offsetWidth
    var actualHeight = $tip[0].offsetHeight

    if (placement == 'top' && actualHeight != height) {
      offset.top = offset.top + height - actualHeight
    }

    var delta = this.getViewportAdjustedDelta(placement, offset, actualWidth, actualHeight)

    if (delta.left) offset.left += delta.left
    else offset.top += delta.top

    var isVertical          = /top|bottom/.test(placement)
    var arrowDelta          = isVertical ? delta.left * 2 - width + actualWidth : delta.top * 2 - height + actualHeight
    var arrowOffsetPosition = isVertical ? 'offsetWidth' : 'offsetHeight'

    $tip.offset(offset)
    this.replaceArrow(arrowDelta, $tip[0][arrowOffsetPosition], isVertical)
  }

  Tooltip.prototype.replaceArrow = function (delta, dimension, isVertical) {
    this.arrow()
      .css(isVertical ? 'left' : 'top', 50 * (1 - delta / dimension) + '%')
      .css(isVertical ? 'top' : 'left', '')
  }

  Tooltip.prototype.setContent = function () {
    var $tip  = this.tip()
    var title = this.getTitle()

    $tip.find('.tooltip-inner')[this.options.html ? 'html' : 'text'](title)
    $tip.removeClass('fade in top bottom left right')
  }

  Tooltip.prototype.hide = function (callback) {
    var that = this
    var $tip = $(this.$tip)
    var e    = $.Event('hide.bs.' + this.type)

    function complete() {
      if (that.hoverState != 'in') $tip.detach()
      if (that.$element) { // TODO: Check whether guarding this code with this `if` is really necessary.
        that.$element
          .removeAttr('aria-describedby')
          .trigger('hidden.bs.' + that.type)
      }
      callback && callback()
    }

    this.$element.trigger(e)

    if (e.isDefaultPrevented()) return

    $tip.removeClass('in')

    $.support.transition && $tip.hasClass('fade') ?
      $tip
        .one('bsTransitionEnd', complete)
        .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
      complete()

    this.hoverState = null

    return this
  }

  Tooltip.prototype.fixTitle = function () {
    var $e = this.$element
    if ($e.attr('title') || typeof $e.attr('data-original-title') != 'string') {
      $e.attr('data-original-title', $e.attr('title') || '').attr('title', '')
    }
  }

  Tooltip.prototype.hasContent = function () {
    return this.getTitle()
  }

  Tooltip.prototype.getPosition = function ($element) {
    $element   = $element || this.$element

    var el     = $element[0]
    var isBody = el.tagName == 'BODY'

    var elRect    = el.getBoundingClientRect()
    if (elRect.width == null) {
      // width and height are missing in IE8, so compute them manually; see https://github.com/twbs/bootstrap/issues/14093
      elRect = $.extend({}, elRect, { width: elRect.right - elRect.left, height: elRect.bottom - elRect.top })
    }
    var isSvg = window.SVGElement && el instanceof window.SVGElement
    // Avoid using $.offset() on SVGs since it gives incorrect results in jQuery 3.
    // See https://github.com/twbs/bootstrap/issues/20280
    var elOffset  = isBody ? { top: 0, left: 0 } : (isSvg ? null : $element.offset())
    var scroll    = { scroll: isBody ? document.documentElement.scrollTop || document.body.scrollTop : $element.scrollTop() }
    var outerDims = isBody ? { width: $(window).width(), height: $(window).height() } : null

    return $.extend({}, elRect, scroll, outerDims, elOffset)
  }

  Tooltip.prototype.getCalculatedOffset = function (placement, pos, actualWidth, actualHeight) {
    return placement == 'bottom' ? { top: pos.top + pos.height,   left: pos.left + pos.width / 2 - actualWidth / 2 } :
           placement == 'top'    ? { top: pos.top - actualHeight, left: pos.left + pos.width / 2 - actualWidth / 2 } :
           placement == 'left'   ? { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left - actualWidth } :
        /* placement == 'right' */ { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left + pos.width }

  }

  Tooltip.prototype.getViewportAdjustedDelta = function (placement, pos, actualWidth, actualHeight) {
    var delta = { top: 0, left: 0 }
    if (!this.$viewport) return delta

    var viewportPadding = this.options.viewport && this.options.viewport.padding || 0
    var viewportDimensions = this.getPosition(this.$viewport)

    if (/right|left/.test(placement)) {
      var topEdgeOffset    = pos.top - viewportPadding - viewportDimensions.scroll
      var bottomEdgeOffset = pos.top + viewportPadding - viewportDimensions.scroll + actualHeight
      if (topEdgeOffset < viewportDimensions.top) { // top overflow
        delta.top = viewportDimensions.top - topEdgeOffset
      } else if (bottomEdgeOffset > viewportDimensions.top + viewportDimensions.height) { // bottom overflow
        delta.top = viewportDimensions.top + viewportDimensions.height - bottomEdgeOffset
      }
    } else {
      var leftEdgeOffset  = pos.left - viewportPadding
      var rightEdgeOffset = pos.left + viewportPadding + actualWidth
      if (leftEdgeOffset < viewportDimensions.left) { // left overflow
        delta.left = viewportDimensions.left - leftEdgeOffset
      } else if (rightEdgeOffset > viewportDimensions.right) { // right overflow
        delta.left = viewportDimensions.left + viewportDimensions.width - rightEdgeOffset
      }
    }

    return delta
  }

  Tooltip.prototype.getTitle = function () {
    var title
    var $e = this.$element
    var o  = this.options

    title = $e.attr('data-original-title')
      || (typeof o.title == 'function' ? o.title.call($e[0]) :  o.title)

    return title
  }

  Tooltip.prototype.getUID = function (prefix) {
    do prefix += ~~(Math.random() * 1000000)
    while (document.getElementById(prefix))
    return prefix
  }

  Tooltip.prototype.tip = function () {
    if (!this.$tip) {
      this.$tip = $(this.options.template)
      if (this.$tip.length != 1) {
        throw new Error(this.type + ' `template` option must consist of exactly 1 top-level element!')
      }
    }
    return this.$tip
  }

  Tooltip.prototype.arrow = function () {
    return (this.$arrow = this.$arrow || this.tip().find('.tooltip-arrow'))
  }

  Tooltip.prototype.enable = function () {
    this.enabled = true
  }

  Tooltip.prototype.disable = function () {
    this.enabled = false
  }

  Tooltip.prototype.toggleEnabled = function () {
    this.enabled = !this.enabled
  }

  Tooltip.prototype.toggle = function (e) {
    var self = this
    if (e) {
      self = $(e.currentTarget).data('bs.' + this.type)
      if (!self) {
        self = new this.constructor(e.currentTarget, this.getDelegateOptions())
        $(e.currentTarget).data('bs.' + this.type, self)
      }
    }

    if (e) {
      self.inState.click = !self.inState.click
      if (self.isInStateTrue()) self.enter(self)
      else self.leave(self)
    } else {
      self.tip().hasClass('in') ? self.leave(self) : self.enter(self)
    }
  }

  Tooltip.prototype.destroy = function () {
    var that = this
    clearTimeout(this.timeout)
    this.hide(function () {
      that.$element.off('.' + that.type).removeData('bs.' + that.type)
      if (that.$tip) {
        that.$tip.detach()
      }
      that.$tip = null
      that.$arrow = null
      that.$viewport = null
      that.$element = null
    })
  }


  // TOOLTIP PLUGIN DEFINITION
  // =========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.tooltip')
      var options = typeof option == 'object' && option

      if (!data && /destroy|hide/.test(option)) return
      if (!data) $this.data('bs.tooltip', (data = new Tooltip(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.tooltip

  $.fn.tooltip             = Plugin
  $.fn.tooltip.Constructor = Tooltip


  // TOOLTIP NO CONFLICT
  // ===================

  $.fn.tooltip.noConflict = function () {
    $.fn.tooltip = old
    return this
  }

}(jQuery);

/* ========================================================================
 * Bootstrap: popover.js v3.3.7
 * http://getbootstrap.com/javascript/#popovers
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // POPOVER PUBLIC CLASS DEFINITION
  // ===============================

  var Popover = function (element, options) {
    this.init('popover', element, options)
  }

  if (!$.fn.tooltip) throw new Error('Popover requires tooltip.js')

  Popover.VERSION  = '3.3.7'

  Popover.DEFAULTS = $.extend({}, $.fn.tooltip.Constructor.DEFAULTS, {
    placement: 'right',
    trigger: 'click',
    content: '',
    template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
  })


  // NOTE: POPOVER EXTENDS tooltip.js
  // ================================

  Popover.prototype = $.extend({}, $.fn.tooltip.Constructor.prototype)

  Popover.prototype.constructor = Popover

  Popover.prototype.getDefaults = function () {
    return Popover.DEFAULTS
  }

  Popover.prototype.setContent = function () {
    var $tip    = this.tip()
    var title   = this.getTitle()
    var content = this.getContent()

    $tip.find('.popover-title')[this.options.html ? 'html' : 'text'](title)
    $tip.find('.popover-content').children().detach().end()[ // we use append for html objects to maintain js events
      this.options.html ? (typeof content == 'string' ? 'html' : 'append') : 'text'
    ](content)

    $tip.removeClass('fade top bottom left right in')

    // IE8 doesn't accept hiding via the `:empty` pseudo selector, we have to do
    // this manually by checking the contents.
    if (!$tip.find('.popover-title').html()) $tip.find('.popover-title').hide()
  }

  Popover.prototype.hasContent = function () {
    return this.getTitle() || this.getContent()
  }

  Popover.prototype.getContent = function () {
    var $e = this.$element
    var o  = this.options

    return $e.attr('data-content')
      || (typeof o.content == 'function' ?
            o.content.call($e[0]) :
            o.content)
  }

  Popover.prototype.arrow = function () {
    return (this.$arrow = this.$arrow || this.tip().find('.arrow'))
  }


  // POPOVER PLUGIN DEFINITION
  // =========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.popover')
      var options = typeof option == 'object' && option

      if (!data && /destroy|hide/.test(option)) return
      if (!data) $this.data('bs.popover', (data = new Popover(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.popover

  $.fn.popover             = Plugin
  $.fn.popover.Constructor = Popover


  // POPOVER NO CONFLICT
  // ===================

  $.fn.popover.noConflict = function () {
    $.fn.popover = old
    return this
  }

}(jQuery);


$(document).ready(Forum.init);
